"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AccordionDetails.default;
  }
});

var _AccordionDetails = _interopRequireDefault(require("./AccordionDetails"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/AccordionDetails/index.js
// module id = 361
// module chunks = 0